import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import HomePage from "./pages/HomePage";
import CatalogPage from "./pages/CatalogPage";
import VehicleDetailPage from "./pages/VehicleDetailPage";
import AdminPage from "./pages/AdminPage";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import InstallPWA from "./components/InstallPWA";

function App() {
  return (
    <div className="min-h-screen bg-zinc-100 flex flex-col">
      <BrowserRouter>
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/catalogo" element={<CatalogPage />} />
            <Route path="/veicolo/:id" element={<VehicleDetailPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
      <Toaster position="bottom-right" />
      <InstallPWA />
    </div>
  );
}

export default App;
